export const categories = [
  {
    slug: 'short-video',
    name: '短视频创作',
    description: '掌握短视频拍摄、剪辑、运营全流程技巧，从零开始成为优秀创作者',
    icon: 'ri-video-line',
  },
  {
    slug: 'creator-skills',
    name: '创作技巧',
    description: '深度解析内容创作方法论，提升视频质量与观众互动率',
    icon: 'ri-lightbulb-line',
  },
  {
    slug: 'monetization',
    name: '变现攻略',
    description: '探索多元变现路径，让创作价值最大化，实现内容商业闭环',
    icon: 'ri-money-cny-circle-line',
  },
  {
    slug: 'platform-news',
    name: '平台动态',
    description: '第一时间了解快猫平台最新政策、功能更新与活动资讯',
    icon: 'ri-news-line',
  },
  {
    slug: 'safety-guide',
    name: '安全指南',
    description: '了解平台安全保障机制，学习账号保护与内容合规操作规范',
    icon: 'ri-shield-check-line',
  },
];